import {createContext} from 'react'

export const ReactionContext = createContext()
